import http from '@/utils/http';

export function getInfo(id) {
  return http.get(`/dispute/account/refund/detail?txnId=${id}`);
}

export function refund(data) {
  return http.post('/dispute/account/refund', data);
}
